module.exports = __webpack_public_path__ + "static/img/give_up.c8c1c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/img/give_up.png
// module id = 2Da2
// module chunks = 1